"use client";
import { sendDownloadEvent } from "@/app/_ga4/eventHandler";
import Image from "next/image";
import Link from "next/link";
import React from "react";

export default function MachineSections(props) {
  const machines = props.data.data;
  return (
    <div className="padded-section">
      {machines.map((machine) => (
        <div className="support-section" key={machine.id}>
          <div className="support-section-header">
            <h2>{machine.attributes.name}</h2>
          </div>
          <div className="support-section-body">
            <div className="support-image-wrapper">
              <Image
                src={machine.attributes.main_image.data.attributes.url}
                width={1920}
                height={1080}
                alt={machine.attributes.main_image.alternativeText || "null"}
              />
            </div>
            <div className="support-downloads">
              {machine.attributes.manuals.map((manual) => (
                <Link
                  href={manual.url}
                  key={manual.id}
                  target="blank"
                  onClick={() =>
                    sendDownloadEvent(
                      manual.manual_type.data.attributes.name,
                      manual.manual_type.data.attributes.name
                    )
                  }
                >
                  <div className="download" key={manual.id}>
                    <div>
                      <Image
                        src={
                          manual.manual_type.data.attributes.image.data
                            .attributes.url
                        }
                        width={1920}
                        height={1080}
                        alt="test"
                      />
                    </div>
                    <span>{manual.manual_type.data.attributes.name}</span>
                  </div>
                </Link>
              ))}
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}
